module.exports = __webpack_public_path__ + "img/exect.e6369a8f.svg";